module.exports = __webpack_public_path__ + "static/media/Electronic_Chime-KevanGC-495939803.b2a5951b.wav";